import styles from "./styles.module.css";

import React from "react";

export const Loader = () => {
  return <div className={styles.loader}>{/* <h2>Cargando....</h2> */}</div>;
};
